import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeDescription: (value: string) => void;
}

export const DescriptionField: React.FC<IProps> = ({ changeDescription }) => {
	return (
		<FormInput
			testId="DescriptionField"
			name="description"
			label="descriptionLabel"
			type="textArea"
			onChange={changeDescription}
		/>
	);
};
